import type { RxJsonSchema } from 'rxdb'

export interface CycleDocument {
  id: string
  envId: string
  projectId: string
  name: string
  number: number
  startDate: number
  endDate: number
  status: 'draft' | 'active' | 'completed'
  description: string | null
  completedOn: number | null
  completedBy: string | null
  isDeleted: boolean
  createdOn: number
  createdBy: string
  updatedOn: number
  updatedBy: string
  deletedOn?: number | null
  deletedBy?: string | null
  updatedAt?: number
}

export const cycleSchema: RxJsonSchema<CycleDocument> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    envId: { type: 'string', maxLength: 36 },
    projectId: { type: 'string', maxLength: 36 },
    name: { type: 'string', maxLength: 100 },
    number: { type: 'number', minimum: 0, maximum: 999999, multipleOf: 1 },
    startDate: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    endDate: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    status: { type: 'string', enum: ['draft', 'active', 'completed'], default: 'draft' },
    description: { type: ['string', 'null'], maxLength: 500 },
    completedOn: { type: ['number', 'null'], minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    completedBy: { type: ['string', 'null'], maxLength: 36 },
    isDeleted: { type: 'boolean', default: false },
    createdOn: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    createdBy: { type: 'string', maxLength: 36 },
    updatedOn: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    updatedBy: { type: 'string', maxLength: 36 },
    deletedOn: { type: ['number', 'null'], minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    deletedBy: { type: ['string', 'null'], maxLength: 36 },
    updatedAt: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
  },
  required: ['id', 'envId', 'projectId', 'name', 'number', 'startDate', 'endDate', 'status', 'isDeleted', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy'],
  indexes: ['envId', 'updatedOn', ['envId', 'isDeleted'], ['envId', 'projectId']],
}

export const cycleMigrationStrategies = {}
